import axios from 'axios'

const instance = axios.create({
    baseURL: String
});

instance.setBaseURL = (url) => {
    window.console.log('Sakali API base URL: ' + url)
    instance.defaults.baseURL = url
}

instance.setAuthtoken = (authtoken) => {
    instance.defaults.headers.common['sandkastenliga.openapi.authtoken'] = authtoken
};

instance.setBaseURL(process.env.VUE_APP_SANDKASTENLIGA_API_URL)

export default instance;


